import React from 'react';
import { AdContextProvider } from '../../store/contexts/ad';
import { Content } from './Content';

export function Ad(): JSX.Element {
  return (
    <AdContextProvider>
      <Content />
    </AdContextProvider>
  );
}
